<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <base-card class="h-full">
              <v-card-text class="pb-0">
                <p class="text-body-2">
                  Imported items last week:
                  <span class="font-weight-bold">
                    {{ lastWeekItemCount }}
                  </span>
                  <br>
                  Total duration of content in hours:
                  <span class="font-weight-bold">
                    {{ totalDurationHours }}
                  </span>
                </p>
              </v-card-text>
            </base-card>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <base-card class="h-full">
              <v-card-text class="pb-0">
                <div class="d-flex align-center">
                  <div>
                    <div class="card-title mb-0">
                      Item distribution
                    </div>
                  </div>
                  <div id="chart1">
                    <apexchart
                      type="donut"
                      :options="providerChart.chartOptions"
                      :series="providerChart.series"
                      :height="120"
                    />
                  </div>
                </div>
              </v-card-text>
            </base-card>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <base-card>
              <v-card-title class="d-flex justify-space-between">
                <div>
                  <div class="card-title mb-0">
                    New Items
                  </div>
                  <p class="text--disabled ma-0 text-body-1">
                    Week: {{ weekChart.lastWeek.name }}
                  </p>
                </div>
                <h5 class="font-weight-bold">
                  +{{ weekChart.lastWeek.count }}
                </h5>
              </v-card-title>
              <v-card-text class="pa-0">
                <div id="chart2">
                  <apexchart
                    type="area"
                    height="50"
                    :options="weekChart.chartOptions"
                    :series="weekChart.series"
                  />
                </div>
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12 mb-20">
        <base-card>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" />
                  <th class="text-left">
                    Company
                  </th>
                  <th class="text-left">
                    Package
                  </th>
                  <th class="text-left">
                    Last Import
                  </th>
                  <th class="text-left">
                    Transcoding Progress
                  </th>
                  <th class="text-left">
                    Projects
                  </th>
                  <th class="text-left">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="source in sources"
                  :key="source.id"
                  class="cursor-pointer"
                  @click="goToSource(source)"
                >
                  <td>
                    <v-icon
                      v-if="source.type === 'mrss'"
                      color="orange"
                    >
                      mdi-rss-box
                    </v-icon>
                    <v-icon
                      v-if="source.type === 'ftp'"
                      color="primary"
                    >
                      mdi-folder-clock
                    </v-icon>
                    <v-icon
                      v-if="source.type === 'excel'"
                      color="green"
                    >
                      mdi-file-excel-box
                    </v-icon>
                  </td>
                  <td class="text-no-wrap text--disabled">
                    {{ source.company || 'n/a' }}
                  </td>
                  <td
                    class="font-weight-medium text-no-wrap"
                  >
                    {{ source.name }}
                  </td>
                  <td class="text-no-wrap text--disabled">
                    {{ moment(source.lastImportTime).format('MMM D, YYYY HH:mm') }}
                  </td>
                  <td>
                    <span class="green--text">{{ source.transcoded }}</span> / {{ source.video }}
                    <v-progress-linear
                      v-model="source.progress"
                      rounded
                      color="success darken-1"
                    />
                  </td>
                  <td>
                    <v-chip
                      v-for="instance in source.instances"
                      :key="instance.id"
                      class="mr-2"
                      :color="instance.active ? 'primary' : 'warning'"
                      small
                    >
                      {{ instance.instanceName }}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      disabled
                      class="mx-2 shadow-none"
                      fab
                      x-small
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      disabled
                      class="mx-2 shadow-none error--text"
                      fab
                      x-small
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </base-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { processInstance, processSource, processSourceInstance } from '@/store/converters'

  export default {
    name: 'Dashboard',
    metaInfo: {
      title: 'Dashboard',
    },
    data () {
      return {
        providerChart: {
          series: [],
          chartOptions: {
            chart: {
              type: 'donut',
            },
            dataLabels: {
              enabled: false,
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      show: false,
                    },
                    value: {
                      show: true,
                    },
                    total: {
                      show: true,
                      label: 'Total',
                      formatter: function (w) {
                        return w.globals.seriesTotals.reduce((a, b) => {
                          return a + b
                        }, 0)
                      },
                    },
                  },
                },
              },
            },
            labels: [],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: 'bottom',
                },
              },
            }],
          },
        },
        weekChart: {
          lastWeek: {
            name: '',
            count: 0,
          },
          series: [{
            name: 'New items',
            data: [],
          }],
          chartOptions: {
            chart: {
              type: 'area',
              sparkline: {
                enabled: true,
              },
            },
            labels: [],
            fill: {
              opacity: 0.3,
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth',
              width: 1,
            },
            grid: {
              show: false,
            },
            xaxis: {
              crosshairs: {
                width: 1,
              },
            },
            yaxis: {
              min: 0,
            },
            colors: ['#7367F0'],
          },
        },
        totalDurationHours: 0,
        lastWeekItemCount: 0,
        polling: null,
        items: [],
        itemId: null,
        playerURL: '',
        item: {
          metadata: '',
          genres: [],
        },
        player: null,
        reportLoaing: false,
        instances: [],
        sources: [],
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
    },
    watch: {
    },
    created () {
      this.loadData()
      this.pollData()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      loadData () {
        this.$store.commit('setPageLoader')

        const params = {
        }
        const instancesReq = this.$store.dispatch('instances', params)

        const sourcesReq = this.$store.dispatch('mediaSources', {'deleted[eq]': 0})

        const statReq = this.$store.dispatch('stat')

        const sourceInstancesReq = this.$store.dispatch('sourceInstances', {})

        Promise.all([instancesReq, sourcesReq, sourceInstancesReq, statReq])
          .then((result) => {
            const instances = result[0] || []
            const instanceMap = {}
            for (let i = 0; i < instances.length; i += 1) {
              const instance = processInstance(instances[i])
              this.instances.push(instance)
              instanceMap[instance.id] = instance.extId
            }

            const sources = result[1] || []
            const sourceMap = {}
            for (let i = 0; i < sources.length; i += 1) {
              const source = processSource(sources[i])
              this.sources.push(source)
              const label = source.name.substring(0, Math.min(10, source.name.length))
              this.providerChart.chartOptions.labels.push(label)
              sourceMap[source.id] = i
            }

            const sourceInstances = result[2] || []
            for (let i = 0; i < sourceInstances.length; i += 1) {
              const instance = processSourceInstance(sourceInstances[i])
              // eslint-disable-next-line no-prototype-builtins
              if (instanceMap.hasOwnProperty(instance.instanceId)) {
                instance.instanceName = instanceMap[instance.instanceId]
              }
              const index = sourceMap[instance.sourceId]
              this.sources[index].instances.push(instance)
            }

            const stat = result[3]
            if (!stat.distribution) {
              stat.distribution = []
            }
            if (!stat.week_stat) {
              stat.week_stat = []
            }

            const distribMap = {}
            for (let i = 0; i < stat.distribution.length; i += 1) {
              distribMap[stat.distribution[i].source_id] = stat.distribution[i]
            }

            this.providerChart.series = []
            for (let i = 0; i < this.sources.length; i += 1) {
              const sourceId = this.sources[i].id
              // eslint-disable-next-line no-prototype-builtins
              if (distribMap.hasOwnProperty(sourceId)) {
                const d = distribMap[sourceId]
                this.sources[i].total = d.count
                this.sources[i].video = d.video_count
                this.sources[i].transcoded = d.transcoded_count
                if (d.video_count > 0) {
                  this.sources[i].progress = d.transcoded_count * 100 / d.video_count
                }
                this.providerChart.series.push(d.count)
              } else {
                this.providerChart.series.push(0)
              }
            }
            if (!stat.total_duration_min) stat.total_duration_min = 0
            this.totalDurationHours = Math.ceil(stat.total_duration_min / 60)

            const series = []
            for (let i = 0; i < stat.week_stat.length; i += 1) {
              series.push(stat.week_stat[i].count)
              this.weekChart.chartOptions.labels.push(stat.week_stat[i].week)
              if (i === stat.week_stat.length - 1) {
                this.weekChart.lastWeek.name = stat.week_stat[i].week
                this.weekChart.lastWeek.count = stat.week_stat[i].count
              }
            }
            if (stat.week_stat.length > 0) {
              this.lastWeekItemCount = stat.week_stat[stat.week_stat.length - 1].count
            }
            this.weekChart.series = [{ data: series, name: 'New items' }]
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      pollData () {
        this.polling = setInterval(() => {
        // this.loadData();
        }, 10000)
      },
      goToSource (source) {
        this.$router.push({
          name: 'PackagePage',
          params: {
            package_id: source.id,
          },
        })
      },
      exportXLS () {
        this.reportLoaing = true
        this.$store.dispatch('getAssetReport')
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'SotalCloud Assets'
            link.click()
            URL.revokeObjectURL(link.href)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.reportLoaing = false)
      },
    },
  }
</script>

<style lang="scss" scoped>
::v-deep .table-one {
  thead.v-data-table-header {
    tr {
      &:hover {
        background-color: #f2f3f8;
      }
      th {
        span {
          font-size: 16px;
          color: #304156;
        }
      }
    }
    tr {
      td {
        padding-bottom: 20px;
        padding-top: 20px;
      }
    }
  }
  tbody {
    tr {
      &:hover {
        background-color: #f2f3f8 !important;
      }
    }
  }
}
</style>
